export default __webpack_public_path__ + "static/big-footer-eaa4d1c4f51746d6704ade5e8ad622f2.svg";